var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lang
    ? _c(
        "div",
        { staticClass: "points-of-interest-list" },
        _vm._l(_vm.poi, function(category, label) {
          return _c(
            "div",
            { key: label, staticClass: "poi-category" },
            [
              Array.isArray(category)
                ? [
                    _c("h3", [
                      _c("img", {
                        attrs: {
                          src: "/img/icons/poi/" + label + ".svg",
                          alt: label
                        }
                      }),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.trans(label)) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "poi-category-data", class: label },
                      _vm._l(category, function(place, index) {
                        return _c("div", { key: index, staticClass: "row" }, [
                          ["railway", "bus"].includes(place.class)
                            ? _c("img", {
                                attrs: {
                                  src: "/img/icons/" + place.icon + ".svg"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "col",
                            domProps: {
                              innerHTML: _vm._s(
                                place.name ? place.name : _vm.trans(label)
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "col-auto",
                            domProps: { innerHTML: _vm._s(place.distance) }
                          })
                        ])
                      }),
                      0
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }